import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConstants } from 'projects/cross-study-portal-lib/src/public-api';

@Injectable()
export class HttpStatus500Interceptor implements HttpInterceptor {
  constructor(private _snackBar: MatSnackBar) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 500) {
              return;
            }

            console.error('Server Error', err);

            this._snackBar.open('Server Error', 'Ok', {
              duration: AppConstants.defaultErrorNotificationTimeoutMs,
            });
          }
        }));
  }
}
